var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PSwitch',{staticStyle:{"margin-top":"5px"},attrs:{"inset":"","color":"primary","prepend-icon":_vm.theme ? 'fa-sun' : 'fa-moon'},model:{value:(_vm.theme),callback:function ($$v) {_vm.theme=$$v},expression:"theme"}})
}
var staticRenderFns = []

export { render, staticRenderFns }